import React from 'react';
import { APP_CONTAINER_ROUTES, TAG_PRINT_BATCH_ROUTES } from './routes';
import { AppContainerStackParams, TagPrintBatchStackParams } from './types';
import { createStackNavigator } from '@react-navigation/stack';
import {
  flexModalCardStyle,
  useModalStackScreenOptions,
} from '@/hooks/use-modal-stack-screen-options';
import { ImportTagPrintTemplateScreen } from '@/screens/partners/import-tag-print-template-screen';
import { RouteProp, useRoute } from '@react-navigation/native';
import { TagPrintBatchDetailScreen } from '@/screens/partners/tag-print-batch-detail-screen';
import { TagPrintBatchItemScreen } from '@/screens/partners/tag-print-batch-item-screen';

const Stack = createStackNavigator<TagPrintBatchStackParams>();

type RouteProps = RouteProp<
  AppContainerStackParams,
  typeof APP_CONTAINER_ROUTES.TagPrintBatch
>;

export const TagPrintBatchStack: React.FC = () => {
  const modalScreenOptions = useModalStackScreenOptions();
  const route = useRoute<RouteProps>();
  const { printTagBatchUUID, selectedTemplateUUID } = route.params;

  return (
    <Stack.Navigator
      initialRouteName={TAG_PRINT_BATCH_ROUTES.Base}
      screenOptions={modalScreenOptions}
    >
      <Stack.Screen
        component={TagPrintBatchDetailScreen}
        initialParams={{ printTagBatchUUID, selectedTemplateUUID }}
        name={TAG_PRINT_BATCH_ROUTES.Base}
      />
      <Stack.Screen
        component={TagPrintBatchItemScreen}
        name={TAG_PRINT_BATCH_ROUTES.Item}
        options={{
          cardStyle: flexModalCardStyle,
        }}
      />
      <Stack.Screen
        component={ImportTagPrintTemplateScreen}
        name={TAG_PRINT_BATCH_ROUTES.ImportTemplate}
      />
    </Stack.Navigator>
  );
};
